import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import Endpoint from "../../shared/endpoints";
import dashboardConstants from "../constants/dashboardConstants";

const getIncomeSummary = () => api.get(Endpoint.retrieveIncomeSummary);

const getClientTypeIncome = (payload: any) =>
  api.get(Endpoint.getClientTypeIncome, {
    params: {
      currency: payload.currency,
    },
  });

const getIncomeChartData = (payload: any) =>
  api.get(Endpoint.getIncomeChartData, {
    params: {
      time: payload.period,
    },
  });

const getPaymentChartData = (payload: any) =>
  api.get(Endpoint.getPaymentChartData, {
    params: {
      time: payload.period,
    },
  });

const getTopEarningAccount = (payload: any) =>
  api.get(Endpoint.retrieveTopEarningAccount, {
    params: {
      currency: payload.currency,
    },
  });

const getTopEarningPlatform = (payload: any) =>
  api.get(Endpoint.retrieveTopEarningPlatform, {
    params: {
      currency: payload.currency,
    },
  });

function* getIncomeSummaryAsync() {
  try {
    const response: AxiosResponse = yield call(getIncomeSummary);
    yield put({
      type: dashboardConstants.GET_INCOME_SUMMARY_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: dashboardConstants.GET_INCOME_SUMMARY_FAILURE,
      err: e,
    });
  }
}

function* getClientTypeIncomeAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getClientTypeIncome,
      action.payload,
    );
    yield put({
      type: dashboardConstants.GET_CLIENT_TYPE_INCOME_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: dashboardConstants.GET_CLIENT_TYPE_INCOME_FAILURE,
      err: e,
    });
  }
}

function* getIncomeChartDataAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getIncomeChartData,
      action.payload,
    );
    yield put({
      type: dashboardConstants.GET_INCOME_CHART_DATA_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: dashboardConstants.GET_INCOME_CHART_DATA_FAILURE,
      err: e,
    });
  }
}

function* getPaymentChartDataAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getPaymentChartData,
      action.payload,
    );
    yield put({
      type: dashboardConstants.GET_PAYMENT_CHART_DATA_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: dashboardConstants.GET_PAYMENT_CHART_DATA_FAILURE,
      err: e,
    });
  }
}

function* getTopEarningAccountAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getTopEarningAccount,
      action.payload,
    );
    yield put({
      type: dashboardConstants.GET_TOP_EARNING_ACCOUNT_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: dashboardConstants.GET_TOP_EARNING_ACCOUNT_FAILURE,
      err: e,
    });
  }
}

function* getTopEarningPlatformAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getTopEarningPlatform,
      action.payload,
    );
    yield put({
      type: dashboardConstants.GET_TOP_EARNING_PLATFORM_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: dashboardConstants.GET_TOP_EARNING_PLATFORM_FAILURE,
      err: e,
    });
  }
}

function* dashboardSaga() {
  yield all([
    takeEvery(
      dashboardConstants.GET_INCOME_SUMMARY_REQUEST,
      getIncomeSummaryAsync,
    ),
    takeEvery(
      dashboardConstants.GET_CLIENT_TYPE_INCOME_REQUEST,
      getClientTypeIncomeAsync,
    ),
    takeEvery(
      dashboardConstants.GET_INCOME_CHART_DATA_REQUEST,
      getIncomeChartDataAsync,
    ),
    takeEvery(
      dashboardConstants.GET_PAYMENT_CHART_DATA_REQUEST,
      getPaymentChartDataAsync,
    ),
    takeEvery(
      dashboardConstants.GET_TOP_EARNING_ACCOUNT_REQUEST,
      getTopEarningAccountAsync,
    ),
    takeEvery(
      dashboardConstants.GET_TOP_EARNING_PLATFORM_REQUEST,
      getTopEarningPlatformAsync,
    ),
  ]);
}

export default dashboardSaga;
